import { Car } from "./CarTypes"

export type Status = "Empty" | "Wrong" | "Close" | "Right"

export type Outcome = {
  madeIn: Status
  manufacturer: Status
  bodyStyle: Status
  poweredBy: Status
  model: Status
}

export type Field = keyof Outcome;

export type GameResult = "NotStarted" | "InProgress" | "Won" | "Lost"

// https://stackoverflow.com/questions/52489261/typescript-can-i-define-an-n-length-tuple-type/52490977#52490977
export type Tuple<T, N extends number> = N extends N ? number extends N ? T[] : _TupleOf<T, N, []> : never;
type _TupleOf<T, N extends number, R extends unknown[]> = R['length'] extends N ? R : _TupleOf<T, N, [T, ...R]>;


export const NUMBER_OF_ROUNDS = 5
type _OutcomeArray<N extends number> = Tuple<Outcome, N>

export type OutcomeArray = _OutcomeArray<typeof NUMBER_OF_ROUNDS>

export type Game = {
  guesses: Car[]
  outcomes: OutcomeArray
  round: number
  gameResult: GameResult 
}